import request from './axios'
import order from './order'
import store from '@/store/index'

const list = {
	user: {
		// 一般帳號登入
		login(params) {
			return request.post(`/front/login`, params)
		},
		// 遊客註冊/登入
		guestLogin(params = {}) {
			return request.post(`/front/guestLogin`, params)
		},
		// 取得當前使用者資訊
		getCurrentBuyer() {
			return request.get(`/front/getCurrentBuyer`)
		},
		// 取得 WebSocket Token
		getWsToken() {
			return request.get(`/ws-token`, {
				params: { source: store.getters.isKiosk ? 'FRONT' : 'GUEST' },
			})
		},
		// 登出
		logout() {
			return request.post(`/logout`)
		},
	},
	order,

	// 取得店家資訊
	getStore: params => request.get('/front/qrcode/getStore', { params }),

	// 店家營業資訊
	getOpenInfo: id => request.get('/front/store/openInfo?storeId=' + id),

	// 取得平台資訊
	getPlatformInfo: () => request.post('/front/getPlatformInfo'),

	// 取得啟用中的自動折扣
	getActiveAutomaticDiscountList: id =>
		request.get('/front/store/getActiveAutomaticDiscountList?storeId=' + id),

	// 取得外送距離計算結果
	checkDeliveryDistance: params =>
		request.post('/front/checkDeliveryDistance', params),
}

// 供 Vuex action 等非元件環境使用
export const api = list

// Vue plugin
export default Vue => {
	Vue.prototype.$api = list
}
